import apiClient from './authService';

const campaignService = {
  // Get all campaigns
  async getCampaigns(year = null) {
    const url = year ? `/campaign?year=${year}` : '/campaign';
    const response = await apiClient.get(url);
    return response.data;
  },

  // Create a new campaign
  async createCampaign(campaignData) {
    const response = await apiClient.post('/campaign', campaignData);
    return response.data;
  },

  // Get all campaign messages with optional filtering
  async getAllMessages(filter = 'ALL') {
    const params = new URLSearchParams({ filter });
    const response = await apiClient.get(`/campaign/all-messages?${params.toString()}`);
    return response.data;
  },

  // Get messages for a specific campaign
  async getCampaignMessages(campaignId, filter = 'ALL') {
    const params = new URLSearchParams({ filter });
    const response = await apiClient.get(`/campaign/${campaignId}/messages?${params.toString()}`);
    return response.data;
  },

  // Get a specific campaign message by ID
  async getMessageById(messageId) {
    const response = await apiClient.get(`/campaign/messages/${messageId}`);
    return response.data;
  },

  // Create a new campaign message
  async createMessage(campaignId, messageData) {
    const response = await apiClient.post(`/campaign/${campaignId}/messages`, messageData);
    return response.data;
  },

  // Update a campaign
  async updateCampaign(campaignId, campaignData) {
    const response = await apiClient.put(`/campaign/${campaignId}`, campaignData);
    return response.data;
  },

  // Update a campaign message
  async updateMessage(campaignId, messageId, messageData) {
    const response = await apiClient.put(`/campaign/messages/${messageId}`, messageData);
    return response.data;
  }
};

export { campaignService };
